@switch (state) {
  @case ("loading") {
    <div class="ds ds--skel" role="status" aria-label="Loading delivery receipts">
      <span class="bk-skel" style="width: 132px; height: 34px"></span>
      <span class="bk-skel" style="width: 100%; height: 6px"></span>
      <div class="ds__tiles" aria-hidden="true">
        @for (n of [0, 1, 2, 3]; track n) {
          <span class="bk-skel ds__tile-skel"></span>
        }
      </div>
    </div>
  }
  @case ("error") {
    <p class="ds__note">
      Delivery receipts could not be loaded. Refresh the page to try again.
    </p>
  }
  @case ("ready") {
    @if (total === 0) {
      <p class="ds__note">
        No delivery receipts yet. They usually start arriving a few minutes after
        a message goes out.
      </p>
    } @else {
      <div class="ds">
        <div class="ds__lead">
          <span class="ds__share">{{ share }}</span>
          <span class="ds__share-label">{{ leadLabel }}</span>
          @if (failed > 0) {
            <span class="ds__failed">{{ formatCount(failed) }} failed</span>
          }
        </div>

        <!-- Proportional: delivered, then failed, then no receipt yet -->
        <div class="ds__bar" role="img" [attr.aria-label]="breakdown">
          <span class="ds__seg ds__seg--ok" [style.flex-grow]="delivered"></span>
          @if (failed > 0) {
            <span class="ds__seg ds__seg--bad" [style.flex-grow]="failed"></span>
          }
          <span class="ds__seg ds__seg--wait" [style.flex-grow]="inFlight"></span>
        </div>

        <div class="ds__tiles">
          @for (tile of tiles; track tile.filter) {
            <button
              type="button"
              class="ds__tile"
              [class.is-active]="mode === 'filter' && active === tile.filter"
              [class.is-bad]="tile.bad"
              [attr.aria-pressed]="mode === 'filter' ? active === tile.filter : null"
              [attr.title]="tileTitle(tile)"
              (click)="pick.emit(tile.filter)"
            >
              <span class="ds__value">{{ tile.value }}</span>
              <span class="ds__label">
                @if (tile.swatch) {
                  <span class="ds__swatch" [attr.data-key]="tile.swatch" aria-hidden="true"></span>
                }
                {{ tile.label }}
              </span>
              @if (tile.note) {
                <span class="ds__note">{{ tile.note }}</span>
              }
            </button>
          }
        </div>

        @if (blacklisted) {
          <p class="ds__aside">
            <span class="bk-sym" aria-hidden="true">block</span>
            {{ formatCount(blacklisted) }}
            {{ blacklisted === 1 ? "blacklisted number was" : "blacklisted numbers were" }}
            left out of this send.
          </p>
        }
      </div>
    }
  }
  @default {
    <ng-content />
  }
}
